import Drawer from '@material-ui/core/Drawer';
import React, { PropsWithoutRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { setRuntimeVariable } from '~/actions/runtime';
import useToggle from '../../../../hooks/useToggle';
import useCreateUserProfile from '../../hooks/useCreateUserProfile';
import AboutUsModal from '../AboutUsModal';
import AddProfileModal from '../AddProfileModal';
import DrawerMenuList from '../DrawerMenuList';
import MemberContactUsModal from '../MemberContactUsModal';

const StyledDrawer = styled(Drawer).withConfig({ componentId: 'sc-1vyzh9j-0' })`
  & .drawer-paper {
    width: 90vw;
    max-width: 400px;
    overflow-x: hidden;
  }
`;

type OwnProps = {
  anchorPosition: 'right' | 'left';
  onClose: () => void;
  currentProfile: any;
  handleLogout: () => void;
  accountSummary: any;
  isAccountDrawerOpen: boolean;
};

const AccountDrawer = (props: PropsWithoutRef<OwnProps>) => {
  const {
    isAccountDrawerOpen,
    anchorPosition,
    onClose,
    currentProfile,
    handleLogout,
    accountSummary,
  } = props;

  const submitting = useSelector((state: any) => state.runtime.ajaxPending);
  const [aboutUsModal, toggleAboutUsModal] = useToggle();
  const [addFamilyModal, toggleAddFamilyModal] = useToggle();
  const handleCreateProfile = useCreateUserProfile(onClose);
  const [memberContactUsModal, toggleMemberContactUsModal] = useToggle();
  const dispatch = useDispatch();

  // closes Intercom chat so that it doesnt overlap with the account drawer.
  useEffect(() => {
    if (isAccountDrawerOpen) {
      dispatch(setRuntimeVariable({ name: 'showConciergeChat', value: false }));
    }
  }, [dispatch, isAccountDrawerOpen]);

  return (
    <StyledDrawer
      anchor={anchorPosition}
      classes={{ paper: 'drawer-paper' }}
      onClose={onClose}
      open={isAccountDrawerOpen}
    >
      <div data-testid="LoggedInMenu" role="button" tabIndex={0}>
        <DrawerMenuList
          accountSummary={accountSummary}
          currentProfile={currentProfile}
          handleLogout={handleLogout}
          onClose={onClose}
          toggleAboutUsModal={toggleAboutUsModal}
          toggleAddFamilyModal={toggleAddFamilyModal}
          toggleMemberContactUsModal={toggleMemberContactUsModal}
        />
        <AddProfileModal
          accountSummary={accountSummary}
          closeModal={toggleAddFamilyModal}
          createUserProfile={handleCreateProfile}
          open={addFamilyModal}
          submitting={submitting}
        />
        <AboutUsModal closeModal={toggleAboutUsModal} open={aboutUsModal} />
        <MemberContactUsModal closeModal={toggleMemberContactUsModal} open={memberContactUsModal} />
      </div>
    </StyledDrawer>
  );
};

AccountDrawer.defaultProps = {
  anchorPosition: 'right',
};

export default AccountDrawer;
